<template>
    <div v-show="statusLoadingData" class="lg:mt-10 lg:sticky lg:top-0 lg:h-screen lg:flex lg:ml-2 max-lg:mx-auto font-poppins">
        <form @submit.prevent="getPesquisa">
            <div class="lg:w-[24rem] max-lg:w-full max-lg:mx-auto">
                <div class="lg:items-left max-lg:mx-auto">
                    <div class="flex flex-col p-2">
                        <label class=" max-lg:mt-8 text-neutral-900 font-semibold" for="plano">Plano<span class="text-red-600">*</span></label>
                        <VueSelect v-model="form.planoValue" :clearable="false" :options="planos" :reduce="plano => plano.plano" label="nome">
                            <template #search="{attributes, events}">
                                <input style="padding: 2.5px;" class="vs__search" :required="!form.planoValue" v-bind="attributes" v-on="events" />
                            </template>          
                        </VueSelect>


                        <label class="mt-3 text-neutral-900 font-semibold" for="uf">U.F<span class="text-red-600">*</span></label>
                        <VueSelect v-model="form.estadoValue" :clearable="false" :reduce=" value => value.value" :disabled="!form.planoValue" :options="[{label: 'Minas Gerais', value: 'MG'}]">
                            <template #search="{attributes, events}">
                                <input style="padding: 2.5px;" class="vs__search" :required="!form.estadoValue" v-bind="attributes" v-on="events" />
                            </template>          
                        </VueSelect>

            
                        <label class="mt-3 text-neutral-900 font-semibold " for="cidade">Cidade<span class="text-red-600">*</span></label>
                        <VueSelect v-model="form.cidadeValue" :clearable="false" :disabled="!form.estadoValue" :options="cidades" :reduce="cidade => cidade.cidade" label="nome">
                            <template #search="{attributes, events}">
                                <input style="padding: 2.5px;" class="vs__search" :required="!form.cidadeValue" v-bind="attributes" v-on="events" />
                            </template>          
                        </VueSelect>
                
                        <label class="mt-3 text-neutral-900 font-semibold " for="bairro">Bairro</label> 
                        <input class="w-full p-2 h-10 border-2 border-neutral-600 rounded" v-model="form.bairroValue" :disabled="!form.cidadeValue" type="text" id="bairro">
                
                        <label class="mt-3 text-neutral-900 font-semibold " for="estabelecimento">Tipos de Estabelecimentos<span class="text-red-600">*</span></label>
                        <VueSelect v-model="form.estabValue" :clearable="false" :options="tipos" :reduce="estabelecimento => estabelecimento.tipo" label="nome" @input="getEspecialidades">
                            <template #search="{attributes, events}">
                                <input style="padding: 2.5px;" class="vs__search" :required="!form.estabValue" v-bind="attributes" v-on="events" />
                            </template>          
                        </VueSelect>

                        <label class="mt-3 text-neutral-900 font-semibold " for="especialidade">Especialidade<span class="text-red-600">*</span></label>

                        <VueSelect v-model="form.espValue" :clearable="false" :disabled="statusLoadingEspecialidade" :loading="statusLoadingEspecialidade" :options="especialidades.espec" :reduce="especialidades => especialidades.especialidade" label="nome">
                            <template #search="{attributes, events}">
                                <input :disabled="!form.estabValue" id="espSelect" style="padding: 2.5px;" class="vs__search" :required="!form.espValue" v-bind="attributes" v-on="events" />
                            </template>
                        </VueSelect>
 
                        <label class="mt-2 text-neutral-900 font-semibold" for="nome">Nome</label>
                        <input class="w-full p-2 h-10 border-2 border-neutral-600 rounded" v-model="form.nomeValue" type="text" id="nome">
                        
                        <input  @click="moverPara()" class=" max-lg:p-[13px] mt-6 w-full mx-auto hover:cursor-pointer mr-2 p-2 rounded-lg font-bold tracking-wide text-white" style="background-color: #006e63;" type="submit" :disabled="loadingStatus" value="PESQUISAR">
                        
                        <router-link to="/guia-medico">
                            <button @click="moverPara()" class="mt-4 max-lg:p-[13px] max-lg:mt-6 flex justify-center justify-items-center w-full mx-auto hover:cursor-pointer mr-2 p-2 rounded-lg font-bold tracking-wide text-white" style="background-color: #006e63;" type="button" formnovalidate>
                               <!--  <svg v-if="loadingPDF" aria-hidden="true" class="w-6 h-6 mr-2 left-1/2 text-gray-200 animate-spin dark:text-white fill-neutral-900" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg> -->
                                <span>BAIXAR GUIA MÉDICO</span>
                            </button>
                        </router-link>

                        
                    </div>
                </div>
            </div>
        </form> 
    </div>
</template>

<script>
  import { api } from "@/services/api.js";
  import { mapState } from "vuex";
  import { mapMutations } from "vuex";
  import 'vue-select/dist/vue-select.css';
  import { VueSelect } from "vue-select";


  export default {
    name: "FiltrosPesquisa",
    data() {
        return {
            apiPDF: process.env.VUE_APP_API_URL,
            loadingStatus: false,
            cidades: "",
            planoAtual: "",
            form: {
                planoValue: "",
                estadoValue: "",
                cidadeValue: "",
                estabValue: "",
                espValue: "",
                bairroValue: "",
                nomeValue: "",
                resultado: null,
                resultadoProfissional: null
            },
            cidadePDF: ""
        };
    },

    components: {
        VueSelect
    },

    computed: {
        ...mapState(["planos", "tipos", "statusLoadingResultado", "statusLoadingForm", "statusLoadingData", "statusLoadingEspecialidade", "especialidades"]),
    },

    created() {
        this.$store.dispatch("loadPlanos");
        this.$store.dispatch("loadTipos");
        this.getCidades();
    },

    methods: {

        ...mapMutations(["addLoadingPlano", "addLoadingResultado", "addLoadingEspecialidade", "addLoadingRoute", "addScrollHandler"]),

        async getCidades() {
            this.$store.dispatch("loadLoadingForm", true)
            await api
                .get(`cidades?estado=MG`)
                .then((response) => {
                this.cidades = response.data;
            })

            .finally(() => {
                this.$store.dispatch('loadLoadingForm', false)
            })
        },

        setLoadingButton(){
            this.loadingStatus = true
            setTimeout(() => {
                this.loadingStatus = false
            }, 4000) 
        },

        getPlanoAtual() {
            api
                .get(`planos/${this.form.planoValue}`)
                .then((response) => {

                this.planoAtual = response.data;

                if(Array.isArray(this.planoAtual[1]) == true){
                    this.$store.dispatch("loadPlanoAtual", {
                        plano: this.planoAtual[0]
                    });
                } 
                else {
                    this.$store.dispatch("loadPlanoAtual", {
                        plano: this.planoAtual
                    });
                }

                this.$store.dispatch("loadPrestador", {
                    allResults: null
                });

                this.$store.dispatch("loadProfissional", {
                    Profissionais: null
                });
                
            })
        },

        getEspecialidades() {
            let especialidades = null
            this.form.espValue = " "

            if (this.form.estabValue === "1" || this.form.estabValue === "2" || this.form.estabValue === "3") {
                this.$store.dispatch('loadEspecialidades', {espec: null})
                 api.get("prestadores/especialidades")
                 .then((response) => {
                    especialidades = response.data;
                    this.$store.dispatch('loadEspecialidades', {espec: especialidades})
                    this.$store.dispatch('loadLoadingEspecialidade', true)
                })
            }
            else {
                 api.get("profissionais/especialidades").then((response) => {
                    especialidades = response.data;
                    this.$store.dispatch('loadEspecialidades', {espec: especialidades})
                    this.$store.dispatch('loadLoadingEspecialidade', true)
                })
            }
        },

        searchPrestador(){
            this.form.resultadoProfissional = null;
            this.$store.dispatch("loadProfissional", {
                Profissionais: null
            });
            if ([115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127].includes(this.form.planoValue)) {
                api.get(`prestadores?plano=${this.form.planoValue}&tipo=${this.form.estabValue}&nome=${this.form.nomeValue}&especialidade=${this.form.espValue}&bairro=${this.form.bairroValue}&cidade=${this.form.cidadeValue}&estado=${this.form.estadoValue}`)
                        .then((response) => {
                        this.form.resultado = response.data;

                        this.$store.dispatch("loadPrestador", {
                            allResults: this.form.resultado
                        })
                        .finally(() => {
                            this.addLoadingRoute(false);
                            this.$router.push({ name: 'resultado' })
                        })   
                    })
                        .catch(() => {
                        
                        this.$store.dispatch("loadPrestador", {
                            allResults: null
                        });
                    });
            } else{
                api.get(`prestadores?tipo=${this.form.estabValue}&nome=${this.form.nomeValue}&especialidade=${this.form.espValue}&bairro=${this.form.bairroValue}&cidade=${this.form.cidadeValue}&estado=${this.form.estadoValue}`)
                        .then((response) => {
                        this.form.resultado = response.data;

                        this.$store.dispatch("loadPrestador", {
                            allResults: this.form.resultado
                        })
                        .finally(() => {
                            this.addLoadingRoute(false);
                            this.$router.push({ name: 'resultado' })
                        })   
                    })
                        .catch(() => {
                        
                        this.$store.dispatch("loadPrestador", {
                            allResults: null
                        });
                    });
            }
        },

        searchProfissional(){
            this.form.resultado = null;
            this.$store.dispatch("loadPrestador", {
                allResults: null
            });
            if ([115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127].includes(this.form.planoValue)) {
                api.get(`profissionais?plano=${this.form.planoValue}&nome=${this.form.nomeValue}&especialidade=${this.form.espValue}&bairro=${this.form.bairroValue}&cidade=${this.form.cidadeValue}&estado=${this.form.estadoValue}`)
                    .then((response) => {
                    this.form.resultadoProfissional = response.data;
                    this.$store.dispatch("loadProfissional", {
                        Profissionais: this.form.resultadoProfissional
                    })
                    .finally(() => {
                        this.addLoadingRoute(false);
                        this.$router.push({ name: 'resultado' })
                    })                         
                })
                    .catch(() => {
                    this.$store.dispatch("loadProfissional", {
                        Profissionais: null
                    }); 
                });
            } else {
                api.get(`profissionais?nome=${this.form.nomeValue}&especialidade=${this.form.espValue}&bairro=${this.form.bairroValue}&cidade=${this.form.cidadeValue}&estado=${this.form.estadoValue}`)
                        .then((response) => {
                        this.form.resultadoProfissional = response.data;
                        this.$store.dispatch("loadProfissional", {
                            Profissionais: this.form.resultadoProfissional
                        })
                        .finally(() => {
                            this.addLoadingRoute(false);
                            this.$router.push({ name: 'resultado' })
                        })                    
                    })
                        .catch(() => {
                        this.$store.dispatch("loadProfissional", {
                            Profissionais: null
                        });
                        
                    });
            }
        },
        
        getPesquisa() {
            this.setLoadingButton();
            this.addLoadingRoute(true);
            this.getPlanoAtual();

            if (this.form.estabValue === "1" || this.form.estabValue === "2" || this.form.estabValue === "3") {
                this.searchPrestador();
            }
            else {
                this.searchProfissional();
            }
        },

        moverPara(){
            let larguraWindow = window.innerWidth;
            if (larguraWindow < 1024) {
                this.addScrollHandler(true)
            }
        }
    },
}
</script>


<style>
:root,
:host{
    --vs-dropdown-option--active-bg: #69ca98;
    --vs-border-width: 2px;
    --vs-border-color: #333;
    --vs-dropdown-option-padding: 6px 3px 6px 20px;
    @media (max-width: 1250px) {
        --vs-dropdown-option-padding: 10px 3px 10px 20px;
    };
}
</style>